// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"63":"c6122c50","453":"5e22a65a","458":"48afb22a","895":"efc65fd3"}[chunkId] + ".chunk.js");